/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import { useTranslation } from "react-i18next";
import { CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import "../../i18n";
import { TemporalSelectorModes } from "../../layouts/TemporalSelector/TemporalSelector";
import CustomTooltip from "./CustomTooltip";
import DashboardChartWrapper from "./dashboardChartWrapper.component";
import { DashboardDailyData } from "./DashboardComponent";
import DashboarcComponentTitle from "./DashboardComponentTitle";
import { DailyAggregateData, IDashboardDailyProps } from "./DashboardDailySells";

export interface IDashboardDailyDocumentsProps {
	data: DashboardDailyData;
	reportCaption?: string;
}

const DashboardDailyDocuments: React.FC<IDashboardDailyDocumentsProps & IDashboardDailyProps> = (props) => {
	const { t } = useTranslation();

	const document_numbers_translation = t("zreports.zreport.totalDocumentsNumber");
	const document_avg_translation = t("zreports.zreport.averagePerDocument");

	const documents_number_title =
		props.mode === TemporalSelectorModes.week ? t("dashboard.titles.weekly.total_documents_number") : t("dashboard.titles.monthly.total_documents_number");
	const documents_average_title =
		props.mode === TemporalSelectorModes.week ? t("dashboard.titles.weekly.average_per_document") : t("dashboard.titles.monthly.average_per_document");

	return (
		<DashboardChartWrapper>
			<DashboarcComponentTitle title={documents_number_title} />
			<ResponsiveContainer className={props.responsiveContainerClassName} height={160}>
				<LineChart data={props.data.aggregates} margin={{ left: -20, top: 10 }}>
					<CartesianGrid />

					<XAxis dataKey="dateDay" />
					<Tooltip
						content={({ payload, label, active }: { payload: DailyAggregateData; label: string; active: boolean }) => (
							<CustomTooltip
								payload={payload}
								label={label}
								active={active}
								colorCurrent="#8884d8"
								colorPrevious="#888412"
								payloadCurrentKey={"document_num"}
								payloadPreviousKey={"document_num_compare"}
								mode={props.mode}
							/>
						)}
					/>
					<YAxis tick={{ fontSize: 18 }} />
					<Line name={t("shared.period").toString()} type="monotone" dataKey="document_num" stroke="#8884d8" strokeWidth={2} />
					<Line name={t(props.compareLegendLabel).toString()} type="monotone" dataKey="document_num_compare" stroke="#888412" strokeWidth={1} />
				</LineChart>
			</ResponsiveContainer>
			<hr />
			<DashboarcComponentTitle title={documents_average_title} />
			<ResponsiveContainer className={props.responsiveContainerClassName} width="100%" height={160}>
				<LineChart data={props.data.aggregates} margin={{ left: -20, top: 20 }}>
					<CartesianGrid />

					<XAxis dataKey="dateDay" />
					{/* <Tooltip labelFormatter={() => document_avg_translation} /> */}
					<Tooltip
						content={({ payload, label, active }: { payload: DailyAggregateData; label: string; active: boolean }) => (
							<CustomTooltip
								payload={payload}
								label={label}
								active={active}
								colorCurrent="#8884d8"
								colorPrevious="#888412"
								payloadCurrentKey={"document_avg"}
								payloadPreviousKey={"document_avg_compare"}
								mode={props.mode}
							/>
						)}
					/>
					<YAxis tick={{ fontSize: 18 }} />
					<Line name={t("shared.period").toString()} dataKey="document_avg" stroke="#8884d8" strokeWidth={2} />
					<Line name={t(props.compareLegendLabel).toString()} dataKey="document_avg_compare" stroke="#888123" strokeWidth={1} />
				</LineChart>
			</ResponsiveContainer>
		</DashboardChartWrapper>
	);
};

export default DashboardDailyDocuments;
